import { Injectable } from '@angular/core';
import { NavItem } from 'src/app/models/nav-items';

const MENUITEMS : NavItem[] = [
  {
    displayName: 'Gestion des documents',
    iconName: 'description',
    route: 'documents'
  },
  {
    displayName: 'Partages / statistiques',
    iconName: 'bar_chart',
    route: 'statistiques'
  },
  {
    displayName: 'Déconnexion',
    iconName: 'logout',
    route: 'login'
  }
];

@Injectable()
export class MenuItems {
  getMenuitem(): NavItem[] {
    return MENUITEMS;
  }
}
